export default __webpack_public_path__ + "static/black-bananatex-4f6b71e939c7d4d6fa34e694efd53c0b.png";